import { css, unsafeCSS } from 'lit';
import { fsFontWeightSemibold } from '@cof/fs-tokens';

export const style = css`
  @media (max-width: 600px) {
    .continue-button {
      width: 100%;
    }

    .button-container {
      margin-left: 1.5em;
      margin-right: 1.5em;
    }
  }

  @media (min-width: 601px) {
    .body-content {
      max-width: 34em;
    }

    .button-container {
      max-width: 33rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .message-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .title-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
    text-align: left;
  }

  .body-content {
    padding-top: 1em;
    text-align: left;
  }

  .reasons-section {
    display: inline-block;
    text-align: left;
  }

  .reason-list {
    margin: 0;
    padding-left: 1.5em;
  }

  .search-icon {
    display: block;
    height: 6rem;
    margin: 0 auto 1.5rem;
    width: 6rem;
  }

  .header-body-container {
    padding: 1.5em;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    align-items: center;
  }

  .error-container {
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 2em;
    max-width: 50em;
    min-height: 500px;
  }
`;
